import {eventListeners} from "//gunner.com/cdn/shop/t/611/assets/f_event-listeners.js?v=155614221467380319941717746072";

// setSizingGuideHistory(string)
export const setSizingGuideHistory = (sizingGuideSlide) => {
    return;
    let finderName;
    const visibleFinder = document.querySelector('.sizing-guide-modal_fit-finder-container:not(.hidden)');
    visibleFinder ? finderName = visibleFinder.getAttribute('data-finder-name') : null;

    let sizingGuideSlideFormatted = sizingGuideSlide.toLowerCase().replace(/ /g, '-');

    // Replace the 'Kennel Fit Finder' slide with 'Start'.
    sizingGuideSlideFormatted === 'kennel-fit-finder' ? sizingGuideSlideFormatted = 'start' : null;

    // Push to history state.
    let sizingGuideURL;
    finderName ? sizingGuideURL = '#' + finderName + '-' + sizingGuideSlideFormatted : sizingGuideURL = '#' + sizingGuideSlideFormatted;
    history.pushState({sizingGuideSlide: sizingGuideURL}, '', sizingGuideURL);
};

// Window popstate listener.
// eventListeners.add(window, 'popstate', () => {
//     if (event.state && event.state.sizingGuideSlide) {
//         console.log(event.state.sizingGuideSlide);
//     }
// });

// Modal open listener.
// document.querySelectorAll('.sizing-guide-modal_open').forEach(modalOpenElement => modalOpenElement.addEventListener('click', () => setSizingGuideHistory('sizing-guide-home')));